import { Fade, Box, Typography, Button, Grid, IconButton, useMediaQuery } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DeleteIcon from "@mui/icons-material/Delete";

interface Step4Props {
    activeStep: number;
    images: string[];
    setImages: React.Dispatch<React.SetStateAction<string[]>>;
    handleNext: () => void;
    handleBack: () => void;
}

const Step4: FC<Step4Props> = ({ activeStep, images, setImages, handleNext, handleBack }) => {
    const stepRef = useRef<HTMLDivElement>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const isMobile = useMediaQuery("(max-width:550px)");

    
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const filesArray = Array.from(e.target.files);
            filesArray.forEach((file) => {
                const reader = new FileReader();
                reader.onload = (ev) => {
                    if (ev.target?.result) {
                        setImages((prev) => [...prev, ev.target!.result as string]);
                    }
                };
                reader.readAsDataURL(file);
            });
            e.target.value = "";
        }
    };

    const handleRemoveImage = (idx: number) => {
        setImages((prev) => prev.filter((_, i) => i !== idx));
    };


    useEffect(() => {
        if (activeStep === 3 && stepRef.current && isMobile) {
            const top = stepRef.current.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: "smooth" });
        }
    }, [activeStep, isMobile]);

    
    return (
        <Fade in={activeStep === 3} unmountOnExit>
            <Box sx={{ display: activeStep === 3 ? "flex" : "none", flexDirection: "column", gap: 2 }}>
                <Typography variant="h6" fontWeight={600} color="#bfa14b" mb={1} ref={stepRef}>
                    Dodaj zdjęcia reklamowanego mebla
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={1}>
                    Dodaj do 5 zdjęć przedstawiających wadę lub całość mebla. Akceptowane formaty: JPG, PNG.
                </Typography>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    hidden
                    onChange={handleImageChange}
                    disabled={images.length >= 5}
                />
                <Button
                    variant="outlined"
                    startIcon={<PhotoCamera />}
                    onClick={() => fileInputRef.current?.click()}
                    disabled={images.length >= 5}
                    sx={{
                        borderColor: "#bfa14b",
                        color: "#bfa14b",
                        fontWeight: 600,
                        borderRadius: 2,
                        "&:hover": { borderColor: "#a88d36", color: "#a88d36" }
                    }}
                >
                    Dodaj zdjęcia
                </Button>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    {images.map((img, idx) => (
                        <Grid item xs={6} sm={4} key={idx}>
                            <Box
                                sx={{
                                    position: "relative",
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    boxShadow: "0 2px 8px rgba(191,161,75,0.12)",
                                    border: "1px solid #e0e0e0"
                                }}
                            >
                                <img
                                    src={img}
                                    alt={`Załączone zdjęcie ${idx + 1}`}
                                    style={{ width: "100%", height: 100, objectFit: "cover", display: "block" }}
                                />
                                <IconButton
                                    size="small"
                                    onClick={() => handleRemoveImage(idx)}
                                    sx={{
                                        position: "absolute",
                                        top: 4,
                                        right: 4,
                                        bgcolor: "rgba(255,255,255,0.8)",
                                        "&:hover": { bgcolor: "#ffe" }
                                    }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                    <Button
                        variant="outlined"
                        sx={{
                            borderColor: "#bfa14b",
                            color: "#bfa14b",
                            fontWeight: 600,
                            borderRadius: 2,
                            "&:hover": { borderColor: "#a88d36", color: "#a88d36" }
                        }}
                        onClick={handleBack}
                    >
                        Wstecz
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: "#bfa14b",
                            color: "#fff",
                            fontWeight: 600,
                            px: 4,
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(191,161,75,0.12)",
                            "&:hover": { bgcolor: "#a88d36" }
                        }}
                        onClick={handleNext}
                    // disabled={images.length === 0}
                    >
                        Dalej
                    </Button>
                </Box>
            </Box>
        </Fade>
    )
}

export default Step4;